import { Quote } from '@/models/quote';

export class State {
    public allQuotes: Array<Quote> = new Array<Quote>();
    public allQuotesPageNumber: number = 1;
    public allQuotesPageSize: number = 25;
    public allQuotesTotalPages: number = 1;
    public allQuotesTotal: number = 0;
    public allQuotesFilterStatus: number | string | null = '';
    public allQuotesFrom: string | null = null;
    public allQuotesTo: string | null = null;
}
